export default "__VITE_ASSET__BhDIT251__"